import { Box } from '@mui/material';
import { useLocales } from 'src/locales';

const Line = () => (
  <Box
    component="span"
    sx={{
      flexGrow: 1,
      fontSize: '1.2rem',
      fontWeight: 'bold',
      border: 'solid 1px',
      borderColor: 'primary.main',
    }}
  />
);

export const ConversationNewMessagesDivider = () => {
  const { translate } = useLocales();

  return (
    <Box
      sx={{
        pl: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: 'primary.main',
        fontWeight: 'bold',
        gap: 1,
      }}
    >
      <Line />
      <div>{translate('communicate.divider.new_messages')}</div>
      <Line />
    </Box>
  );
};
